// extracted by mini-css-extract-plugin
module.exports = {"root":"PitchPageBrowseBoats_root__4Xdct","title":"PitchPageBrowseBoats_title__C7OP4"};